import axios from 'axios';
import { handleResponse } from '../helpers/handleResponse';
import { authHeader } from '../services/authHeader';


export const productService = {
    all,
    groups,
    singleGroup,
    updateGroup,
    createGroup,
    removeGroup,
    sync
};

function groups(){
    return axios({
        method: 'get',
        url: '/api/product/groups',
        headers: authHeader()
    }).then(handleResponse);
}

function all(){
    return axios({
        method: 'get',
        url: '/api/product/all',
        headers: authHeader()
    }).then(handleResponse);
}

function singleGroup(handle: string){
    return axios({
        method: 'get',
        url: `/api/product/group/${handle}`,
        headers: authHeader()
    }).then(handleResponse);
}

function removeGroup(handle: string){
    return axios({
        method: 'delete',
        url: `/api/product/group/${handle}`,
        headers: authHeader()
    }).then(handleResponse);
}

function updateGroup(reqBody: any){
    return axios({
        method: 'put',
        url: '/api/product/groups',
        data: reqBody,
        headers: authHeader()
    }).then(handleResponse);
}

function createGroup(reqBody: any){
    return axios({
        method: 'post',
        url: '/api/product/groups',
        data: reqBody,
        headers: authHeader()
    }).then(handleResponse);
}

function sync(){
    return axios({
        method: 'get',
        url: '/api/sync/products',
        headers: authHeader()
    }).then(handleResponse);
}